import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Slideshow from "./pages/Slideshow";
import onFireAPI from "./services/api";
import "./App.css";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  return onFireAPI.isAuthenticated() ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/slideshow" 
            element={
              <ProtectedRoute>
                <Slideshow />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;